import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const InventoryTable = ({ rows, columns, heading }) => {
  return (
    <>
      <div>
        {rows.map((row, index) => (
          <Accordion
            key={index}
            style={{
              border: "1px solid #CCCCCC",
              boxShadow: "0px 0px 12px 0px #0000001F",
              margin: "16px 0",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <img src="/images/radio-icon.svg" alt="check" />
                <Typography>{row[columns[heading].field]}</Typography>{" "}
              </Box>
            </AccordionSummary>
            <AccordionDetails
              style={{ backgroundColor: "#F5F5F5", padding: "0" }}
            >
              {columns.map((column, idx) => (
                <div
                  key={idx}
                  style={{
                    border: "1px solid #CCCCCC",
                    padding: "16px",
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "4pxs",
                  }}
                >
                  <Typography className="pe-1">{column.headerName}</Typography>
                  {typeof row[column.field] === "object" ||
                  column.renderCell ? (
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {column.renderCell
                        ? column.renderCell(row)
                        : row[column.field]}
                    </Box>
                  ) : (
                    <Typography fontWeight={600}>
                      {row[column.field]}
                    </Typography>
                  )}
                  {/* <Typography fontWeight={600}>{row[column.field]}</Typography> */}
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        ))}
      </div>
    </>
  );
};

export default InventoryTable;
